// Meta Pixel ID
const PIXEL_ID = '916313891230397'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

// Initialize Meta Pixel (call once on app load)
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return // already initialized

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  window.fbq('init', PIXEL_ID)
}

// Track PageView
export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

// Track ViewContent
export function trackViewContent(data?: {
  content_name?: string
  content_type?: string
  value?: number
  currency?: string
}): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: data?.content_name || 'El Método Barrita Pro',
      content_type: data?.content_type || 'product',
      value: data?.value || 16990,
      currency: data?.currency || 'ARS',
    })
  }
}

// Track AddToCart
export function trackAddToCart(data?: {
  content_name?: string
  content_type?: string
  value?: number
  currency?: string
}): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: data?.content_name || 'El Método Barrita Pro',
      content_type: data?.content_type || 'product',
      value: data?.value || 16990,
      currency: data?.currency || 'ARS',
    })
  }
}
